import React, { type ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadAlbumsListRequest } from 'reactApp/modules/albums/albums.actions';
import { CUSTOM_ALBUMS_ID } from 'reactApp/modules/albums/albums.constants';
import { getAlbumsItemById, getCustomAlbumsList } from 'reactApp/modules/albums/albums.selector';
import { isAlbum } from 'reactApp/modules/albums/albums.types';
import type { RootState } from 'reactApp/store';
import { SelectAlbumPopup } from 'reactApp/ui/SelectAlbumPopup/SelectAlbumPopup';
import type { SelectAlbumCallbackProps, SelectAlbumTextProps } from 'reactApp/ui/SelectAlbumPopup/SelectAlbumPopup.types';

export interface SelectCustomAlbumPopupProps extends SelectAlbumCallbackProps {}

const texts: SelectAlbumTextProps = {
    title: 'Выберите альбом',
    createAlbumBttnText: 'Создать альбом',
    successBttnText: 'Добавить в альбом',
    emptyTitle: 'У вас пока нет альбомов',
    emptyText: 'Создайте свой первый альбом и добавляйте в него фото',
    emptyBttnText: 'Создать альбом',
};

export function SelectCustomAlbumPopup(props: SelectCustomAlbumPopupProps): ReactElement {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(loadAlbumsListRequest());
    }, []);

    const albums = useSelector(getCustomAlbumsList);
    const album = useSelector((state: RootState) => getAlbumsItemById(state, CUSTOM_ALBUMS_ID));
    const error = isAlbum(album) ? album.error : undefined;
    const isLoading = isAlbum(album) ? !album.isLoaded && album.isLoading : true;

    return <SelectAlbumPopup albums={albums} error={Boolean(error)} isLoading={Boolean(isLoading)} {...props} {...texts} />;
}
